import { Box, Flex, Heading3, IconicButton } from "@nulogy/components";
import React, { useState } from "react";
import styled from "styled-components";

const HeaderContainer = styled(Flex)(({ theme }) => ({
  alignItems: "center",
  cursor: "pointer",
  justifyContent: "space-between",
  padding: theme.sizes.x3,
}));

const AccordionBox = styled(Box)(({ theme }) => ({
  border: "1px",
  borderColor: theme.colors.lightGrey,
  borderRadius: theme.sizes.half,
  borderStyle: "solid",
  marginBottom: theme.sizes.x3,
  marginTop: theme.sizes.x3,
}));

const Accordion = ({ children, heading, sideNote }) => {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => {
    setExpanded(!expanded);
  };

  const icon = expanded ? "downArrow" : "rightArrow";

  return (
    <AccordionBox>
      <HeaderContainer className="spec-accordion-header" onClick={() => toggle()}>
        <Box p={0}>
          <Flex alignItems="center" width="100%">
            <IconicButton color="black" data-testid="accordion-toggle" icon={icon} paddingRight="x1" type="button" />
            <Heading3 mb={0}>{heading}</Heading3>
          </Flex>
        </Box>
        <Box color="midGrey" fontWeight="light" lineHeight="x3">
          {sideNote}
        </Box>
      </HeaderContainer>

      {expanded ? (
        <Box marginLeft="x3" marginRight="x3">
          {children}
        </Box>
      ) : null}
    </AccordionBox>
  );
};

export default Accordion;
